import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { DataRefreshProvider, useDataRefresh } from './context/DataRefreshContext';
import { useAuth } from './hooks/useAuth';
import { dataCache } from './lib/dataCache';

// Warm the cache right after login; clear it on logout so a new user never
// sees the previous user's cached data.
function PrefetchGate() {
  const { session, profile } = useAuth();
  const { prefetchAll } = useDataRefresh();

  useEffect(() => {
    if (session && profile) prefetchAll();
  }, [session, profile, prefetchAll]);

  useEffect(() => {
    if (!session) dataCache.clearAll();
  }, [session]);

  return null;
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <DataRefreshProvider>
            <PrefetchGate />
            <App />
          </DataRefreshProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
